import { usePermissions } from '../common/hooks/usePermissions';

const Feature = ({name, children}) => {
    const { flags } = usePermissions();

    if (flags === null || flags.length === 0 || flags.length === undefined) {
        return null;
    }

    if (flags.includes(name)) {
        return children;
    }

    const feature = Array.isArray(name) 
        ? flags.find(feature => name.includes(feature.name))
        : flags.find(feature => feature.name === name);

    if (feature && feature.active) {
        return children;
    }

    return null;
};

export default Feature;
